import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { RedirectIfAuthenticated, RequireAdmin } from './auth/guards.js';
import { AppLayout } from './components/AppLayout.js';
import { FullPageMessage } from './components/FullPageMessage.js';
import { CreateInterviewPage } from './routes/CreateInterviewPage.js';
import { ForgotPasswordPage } from './routes/ForgotPasswordPage.js';
import { InterviewDetailPage } from './routes/InterviewDetailPage.js';
import { InterviewersPage } from './routes/InterviewersPage.js';
import { InterviewsPage } from './routes/InterviewsPage.js';
import { JobProfilesPage } from './routes/JobProfilesPage.js';
import { LoginPage } from './routes/LoginPage.js';
import { ResetPasswordPage } from './routes/ResetPasswordPage.js';

export function App(): ReactElement {
  return (
    <Routes>
      <Route element={<RedirectIfAuthenticated />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        {/* The path the API's password-reset emails link to (invitation-service.ts). */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Route>

      <Route element={<RequireAdmin />}>
        <Route element={<AppLayout />}>
          <Route path="/interviews" element={<InterviewsPage />} />
          {/* Before the :interviewId route so "new" is not read as an id. */}
          <Route path="/interviews/new" element={<CreateInterviewPage />} />
          <Route path="/interviews/:interviewId" element={<InterviewDetailPage />} />
          <Route path="/job-profiles" element={<JobProfilesPage />} />
          <Route path="/interviewers" element={<InterviewersPage />} />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/interviews" replace />} />
      <Route
        path="*"
        element={<FullPageMessage title="Page not found" detail="That page does not exist." />}
      />
    </Routes>
  );
}
